import axios from "axios";
import { apiBaseUrl } from "../../../helpers/UrlHelper";
import { loginToken } from "../../../helpers/LocalStorageHelper";
import { handleError } from "../../../helpers/ErrorHelper";
import { debounce } from "../../../helpers/Debounce";

function _success(success) {
  return { type: "GET_ROLES_SUCCESS", success };
}

function _error(error) {
  return { type: "GET_ROLES_ERROR", error };
}

function _processing(processing) {
  return { type: "GET_ROLES_PROCESSING", processing };
}

function getRoles(shouldDebounce = false) {
  return (dispatch, getState) => {
    dispatch(_processing(true));

    let { params } = getState().roleList.data;

    const request = () =>
      axios({
        url: apiBaseUrl(`admin/roles`),
        method: "get",
        dataType: "json",
        params,
        headers: {
          Authorization: "Bearer " + loginToken(),
        },
      })
        .then(function (res) {
          dispatch(_success(res));
          dispatch(_processing(false));
        })
        .catch(function (error) {
          dispatch(_error(error));
          dispatch(_processing(false));
          handleError(error);
        });

    debounce.makeRequest(request, shouldDebounce);

    // return {
    //   type: "GET_ROLES_SUCCESS",
    //   payload: request,
    // };
  };
}

export default getRoles;
